import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { IPdfModal } from './type';

const initialState: IPdfModal = {
	pdfModel: 'default',
	showFullProductName: false,
	periodToDateTotal: true,
};

export const BLModalSlice = createSlice({
	name: 'pdfModel',
	initialState,
	reducers: {
		setPdfModel(state, action: PayloadAction<'default' | 'para' | 'dynamic'>) {
			state.pdfModel = action.payload;
		},
		setShowFullProductName(state, action: PayloadAction<boolean>) {
			state.showFullProductName = action.payload;
		},
		setPeriodToDateTotal(state, action: PayloadAction<boolean>) {
			state.periodToDateTotal = action.payload;
		},
	},
});

export const { setPdfModel, setShowFullProductName, setPeriodToDateTotal } = BLModalSlice.actions;

export default BLModalSlice.reducer;
